import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import moment from 'moment';
import { i18n } from '../../../../language';
import { downloadFileById, getArrayRandomKey } from '../../../../utils';
import DiaLog from '../../../../components/Dialog';
import { ehandoverAPI } from '../../../../apis';
import StyleButton from '../../../../components/StyleButton';

const useStyles = makeStyles(() => ({
  table: {
    position: 'relative',
    minHeight: '20rem',
    '& .MuiTableCell-root': {
      border: 'none',
      fontSize: '0.875rem',
      fontWeight: '500',
      lineHeight: '1.675rem',
      color: '#2e4469',
      padding: '0.813rem 1.25rem',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      left: '0',
      zIndex: '10',
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
      },
      '& .MuiTableCell-root': {
        fontWeight: 'bold',
        color: '#538fff',
        backgroundColor: '#fff',
        textTransform: 'uppercase',
      },
    },
    '& .MuiTableBody-root': {
      '& > :hover': {
        backgroundColor: '#f5faff',
      },
      '& > .MuiTableRow-root': {
        borderBottom: '1px solid #E6E8E9',
      },
      '& .MuiTableCell-root': {
        height: '3.5rem',
        fontFamily: 'NotoSans-Medium',
      },
    },
    '& .Mui-selected': {
      backgroundColor: '#defff5',
    },
    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: '#28d2ab',
    },
  },
  tableHeadTitle: {
    color: '#538FFF',
    fontSize: '1.142rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: 700,
    wordBreak: 'break-all',
  },
  staffName: {
    fontSize: '1.142rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  corpId: {
    fontSize: '1rem',
    fontWeight: '500',
    color: '#7D86A9',
  },
  dot: {
    width: '10px',
    height: '10px',
    borderRadius: '100%',
    marginRight: '0.571rem',
  },
  exportButton: {
    backgroundColor: '#538fff',
    border: 'unset',
    '&.Mui-disabled': {
      backgroundColor: '#c0c6cb',
    },
  },
}));

export default function AckDetailDialog({ open, closePop, taskId }) {
  const classes = useStyles();
  const [acknowledgeList, setAcknowledgeList] = useState([]);
  const [exporting, setExporting] = useState(false);

  // PENGING,DELETED,ACK,RESEND
  const ackStatusColorMapping = {
    ACK: { color: '#7FD6F1', statusText: 'EHANDOVER_ACK_STATUS_ACKNOWLEDGED' },
    PENDING: { color: '#FFC95C', statusText: 'EHANDOVER_ACK_STATUS_AWAITING' },
    DELETED: { color: '#FA8A82', statusText: 'EHANDOVER_ACK_STATUS_DELETED' },
    RESEND: { color: '#FFC95C', statusText: 'EHANDOVER_ACK_STATUS_AWAITING' },
    RESEND_ACK: { color: '#7FD6F1', statusText: 'EHANDOVER_ACK_STATUS_ACKNOWLEDGED' },
  };

  const getAcknowledgeDetails = async () => {
    try {
      const { result } = await ehandoverAPI.getAcknowledgeDetail({ taskId });
      setAcknowledgeList(result);
    } catch (error) {}
  };
  const exportAckDetail = async () => {
    try {
      setExporting(true);
      await downloadFileById(
        () =>
          ehandoverAPI.ackDetailExport({
            taskId,
          }),
        () => `WardDiary_ack_detail_${moment().valueOf()}`,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );
      setExporting(false);
    } catch (error) {
      console.log(error);
    } finally {
      setExporting(false);
    }
  };

  useEffect(() => {
    (async () => {
      await getAcknowledgeDetails();
    })();
  }, []);

  return (
    <DiaLog
      handleClose={closePop}
      handleCancel={closePop}
      title={i18n.t('EHANDOVER_ACKNOWLEDGEMENT_DETAIL')}
      dialogfootStyle={{ marginTop: '1rem' }}
      open={open}
      width="100%"
      dialogWidth="70%"
      dialogContentStyle={{ overflowY: 'auto' }}
      readOnly={true}
      isCapitalize={false}
    >
      <Box display="flex" justifyContent="flex-end" mb="1rem">
        <StyleButton
          className={classes.exportButton}
          color="#fff"
          width="8rem"
          borderRadius="0.714rem"
          id="ehandover_export_button"
          text={exporting ? i18n.t('EHANDOVER_EXPORTING') : i18n.t('EQUIPMENT_VIEWREQUEST_EXPORT')}
          onClick={exportAckDetail}
          disabled={exporting}
        />
      </Box>
      <Table className={classes.table} aria-label="simple table">
        <TableHead className={classes.tableHead} id="bed_setting_table_head">
          <TableRow>
            <TableCell align="left" className={classes.tableHeadTitle}>
              {i18n.t('EHANDOVER_STAFF_NAME')}
            </TableCell>
            <TableCell align="left" className={classes.tableHeadTitle}>
              {i18n.t('EHANDOVER_ACKNOWLEDGEMENT_STATUS')}
            </TableCell>
            <TableCell align="left" className={classes.tableHeadTitle}>
              {i18n.t('EHANDOVER_ACKNOWLEDGED_AT')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody id="bed_setting_table_body">
          {acknowledgeList.map((row, rowIndex) => {
            const { staffName, corpId, acknowledgmentStatus, acknowledgedAt } = row;
            return (
              <TableRow
                key={getArrayRandomKey(rowIndex, 'ehandover-access-control')}
                id={`e_handover_setting_table_row${rowIndex}`}
              >
                <TableCell align="left">
                  <Box className={classes.staffName}>{staffName}</Box>
                  <Box className={classes.corpId}>{corpId}</Box>
                </TableCell>
                <TableCell align="left">
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <Box
                      className={classes.dot}
                      style={{
                        backgroundColor: ackStatusColorMapping?.[acknowledgmentStatus]?.color,
                      }}
                    />
                    <Box className={classes.staffName}>
                      {i18n.t(ackStatusColorMapping?.[acknowledgmentStatus]?.statusText)}
                    </Box>
                  </Box>
                </TableCell>
                <TableCell align="left">
                  <Box className={classes.staffName}>
                    {acknowledgedAt ? moment(acknowledgedAt).format('YYYY-MM-DD HH:mm:ss') : '-'}
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </DiaLog>
  );
}
